document.addEventListener('DOMContentLoaded', function () {

    const stickyHeader = document.querySelector('.StickyHeader');
    const isScrolledClass = 'isScrolled';

    if (!stickyHeader) return;

    window.addEventListener('scroll', function () {
        recalculateStickyHeaderIsScrolled();
    });

    function recalculateStickyHeaderIsScrolled() {
        if (window.scrollY > 0) {
            stickyHeader.classList.add(isScrolledClass)
        }
        else {
            stickyHeader.classList.remove(isScrolledClass)
        }
    };

    recalculateStickyHeaderIsScrolled();
});